"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const GaButton_1 = __importDefault(require("../../../util/GaButton"));
const StoresUtil_1 = require("../../../util/StoresUtil");
const ContactForm_1 = require("../../contactform/ContactForm");
const PublicPrivacyNoticeContactModal_1 = __importDefault(require("../PublicPrivacyNoticeContactModal"));
let ParagraphTwelveContent = class ParagraphTwelveContent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicPrivacyNoticeStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(lib_1.Grid, null,
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] },
                react_1.default.createElement(lib_1.Image, { srcset: "\n          https://res.cloudinary.com/telia/image/upload/q_auto:best/w_275/v1627382047/iseteenindus/andrus_dpod.jpg 360w,\n          https://res.cloudinary.com/telia/image/upload/q_auto:best/w_275/v1627382047/iseteenindus/andrus_dpod.jpg 720w,\n          https://res.cloudinary.com/telia/image/upload/q_auto:best/w_275/v1627382047/iseteenindus/andrus_dpod.jpg 1080w", width: 246, alt: "Andrus Hinrikus portree" })),
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] },
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("p", { className: "text-bold" }, "Andrus Hinrikus"),
                    react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.twelve.text1')),
                    react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.twelve.text2')),
                    react_1.default.createElement(lib_1.List, { type: "unstyled" },
                        react_1.default.createElement(lib_1.ListItem, null,
                            react_1.default.createElement(lib_1.ModalProvider, null,
                                react_1.default.createElement(lib_1.ModalTrigger, null,
                                    react_1.default.createElement(GaButton_1.default, { id: "privacy-notice-paragraph-12-contact", text: translate('gdpr.privacy.notification.paragraph.twelve.link1'), link: true, iconRight: "#arrow-right", onClick: () => this.publicPrivacyNoticeStore.openContactInformationModal(ContactForm_1.ContactFormType.CONTACT_US) })),
                                react_1.default.createElement(PublicPrivacyNoticeContactModal_1.default, null))),
                        react_1.default.createElement(lib_1.ListItem, null,
                            react_1.default.createElement(GaButton_1.default, { id: "privacy-notice-paragraph-12-additional-information", text: translate('gdpr.privacy.notification.paragraph.twelve.link2'), link: true, url: "https://www.teliacompany.com/en/about-the-company/privacy" })))))));
    }
};
ParagraphTwelveContent = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ParagraphTwelveContent);
exports.default = ParagraphTwelveContent;
